import React from "react";
import { FaCode, FaCogs, FaProjectDiagram } from 'react-icons/fa';

function SolucoesInovadoras() {
  return (
    <section id="section-solucoes" style={styles.container}>
      <h2 style={styles.title}>Como Posso Impulsionar Seu Negócio</h2>

      {/* Serviços Oferecidos */}
      <div style={styles.services}>
        <h3 style={styles.subtitle}>Serviços Oferecidos</h3>
        <div style={styles.cardsContainer}>
          <div style={styles.card}>
            <FaCode size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>Desenvolvimento Web</h4>
            <p style={styles.cardText}>Criação de websites responsivos, lojas virtuais e sistemas personalizados.</p>
          </div>
          <div style={styles.card}>
            <FaCogs size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>Automação de Processos</h4>
            <p style={styles.cardText}>Integração de sistemas, otimização de processos internos e soluções escaláveis.</p>
          </div>
          <div style={styles.card}>
            <FaProjectDiagram size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>Consultoria Técnica</h4>
            <p style={styles.cardText}>Análise de sistemas, melhoria de performance e implementação de tecnologias emergentes.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

const styles = {
  container: {
    backgroundColor: "#F4F4F4",
    padding: "60px 20px",
    textAlign: "center",
  },
  title: {
    fontSize: "32px",
    color: "#333",
    marginBottom: "30px",
    fontWeight: "bold",
  },
  subtitle: {
    fontSize: "24px",
    color: "#444",
    marginBottom: "20px",
    fontWeight: "bold",
  },
  services: {
    marginBottom: "50px",
  },
  cardsContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "30px",
    flexWrap: "wrap",
  },
  card: {
    backgroundColor: "#FFF",
    width: "280px",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  },
  cardTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "15px",
  },
  cardText: {
    fontSize: "14px",
    color: "#666",
  },
  icon: {
    color: "#FF6600",
  },
  technologies: {
    marginBottom: "50px",
  },
  techStack: {
    display: "flex",
    justifyContent: "center",
  },
  techList: {
    listStyle: "none",
    padding: "0",
    fontSize: "16px",
    color: "#444",
    textAlign: "left",
  },
};

export default SolucoesInovadoras;
